export default "__VITE_ASSET__ChKEC8H1__"